import { c as _c } from "react/compiler-runtime";
import React from "react";
const StarIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none"><path d="M16.8234 4.89058C17.2724 3.50861 19.2276 3.50861 19.6766 4.89058L21.9545 11.9012C22.1553 12.5193 22.7312 12.9377 23.3811 12.9377H30.7525C32.2056 12.9377 32.8097 14.7971 31.6342 15.6512L25.6706 19.984C25.1448 20.366 24.9248 21.0431 25.1257 21.6611L27.4035 28.6717C27.8526 30.0537 26.2709 31.2029 25.0953 30.3488L19.1317 26.016C18.6059 25.634 17.8941 25.634 17.3683 26.016L11.4047 30.3488C10.2291 31.2029 8.64742 30.0537 9.09645 28.6717L11.3743 21.6611C11.5752 21.0431 11.3552 20.366 10.8294 19.984L4.86583 15.6512C3.69026 14.7971 4.29442 12.9377 5.74751 12.9377H13.1189C13.7688 12.9377 14.3447 12.5193 14.5455 11.9012L16.8234 4.89058Z" fill="#FFAD0D" /></svg></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default StarIcon;